import React from 'react'
import { Share } from '@which/seatbelt'
import { getSharingUrl } from '../../../components/common/utilities/get-sharing-url'
import './sharing-options-horizontal.scss'

interface Props {
  url: string
  fbappid: string
  twitterText: string
  facebookText: string
  emailSubject: string
}

const WSharingOptionsHorizontal = ({
  url,
  fbappid,
  twitterText,
  facebookText,
  emailSubject,
}: Props): React.ReactElement => {
  return (
    <div className="sharing-options-horizontal-layout" data-testid="sharing-options-horizontal">
      <Share
        links={{
          facebook: getSharingUrl({ url, fbappid, type: 'facebook' }),
          twitter: getSharingUrl({ url, text: twitterText, type: 'twitter' }),
          whatsapp: getSharingUrl({ url, text: facebookText, type: 'whatsApp' }),
          mail: getSharingUrl({ url, text: facebookText, emailSubject, type: 'email' }),
        }}
        headline=""
      />
    </div>
  )
}

export default WSharingOptionsHorizontal
